module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-voxi-intro-card1.1.c04cd6cb.jpg";